/**
 * @generated SignedSource<<d99136fadea1be238f8664a85e9d868e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "subscriptionOrderLandingId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "subscriptionOrderLandingId",
    "variableName": "subscriptionOrderLandingId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "logo",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "accountPath",
  "storageKey": null
},
v4 = [
  {
    "kind": "Literal",
    "name": "orderBy",
    "value": "APP_NAME_ASC"
  }
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalCount",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "appId",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "appName",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "appSku",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "appStatus",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cpId",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "programName",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "concreteType": "CpAppTsConnection",
  "kind": "LinkedField",
  "name": "cpAppTsByAppId",
  "plural": false,
  "selections": [
    (v5/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "CpAppT",
      "kind": "LinkedField",
      "name": "nodes",
      "plural": true,
      "selections": [
        (v10/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "CpT",
          "kind": "LinkedField",
          "name": "cpTByCpId",
          "plural": false,
          "selections": [
            (v11/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "landingPath",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "pageTitle",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "commissionTitle",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "accountPackageId",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "accountPackageAppId",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "nodeId",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "concreteType": "CpAppTsConnection",
  "kind": "LinkedField",
  "name": "cpAppTsByAppId",
  "plural": false,
  "selections": [
    (v5/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "CpAppT",
      "kind": "LinkedField",
      "name": "nodes",
      "plural": true,
      "selections": [
        (v10/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "CpT",
          "kind": "LinkedField",
          "name": "cpTByCpId",
          "plural": false,
          "selections": [
            (v11/*: any*/),
            (v18/*: any*/)
          ],
          "storageKey": null
        },
        (v18/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SubscriptionOrderLandingEditQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "SubscriptionOrderLandingT",
        "kind": "LinkedField",
        "name": "subscriptionOrderLandingTBySubscriptionOrderLandingId",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "AccountT",
            "kind": "LinkedField",
            "name": "accountTByAccountId",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "alias": null,
                "args": (v4/*: any*/),
                "concreteType": "AppTsConnection",
                "kind": "LinkedField",
                "name": "appTsByAccountId",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AppT",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                      (v6/*: any*/),
                      (v7/*: any*/),
                      (v8/*: any*/),
                      (v9/*: any*/),
                      (v12/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "appTsByAccountId(orderBy:\"APP_NAME_ASC\")"
              }
            ],
            "storageKey": null
          },
          (v13/*: any*/),
          (v14/*: any*/),
          (v15/*: any*/),
          (v16/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "AccountPackageT",
            "kind": "LinkedField",
            "name": "accountPackageTByAccountPackageId",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "AccountPackageAppTsConnection",
                "kind": "LinkedField",
                "name": "accountPackageAppTsByAccountPackageId",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AccountPackageAppT",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                      (v6/*: any*/),
                      (v16/*: any*/),
                      (v17/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "AppT",
                        "kind": "LinkedField",
                        "name": "appTByAppId",
                        "plural": false,
                        "selections": [
                          (v7/*: any*/),
                          (v8/*: any*/),
                          (v9/*: any*/),
                          (v12/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SubscriptionOrderLandingEditQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "SubscriptionOrderLandingT",
        "kind": "LinkedField",
        "name": "subscriptionOrderLandingTBySubscriptionOrderLandingId",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "AccountT",
            "kind": "LinkedField",
            "name": "accountTByAccountId",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "alias": null,
                "args": (v4/*: any*/),
                "concreteType": "AppTsConnection",
                "kind": "LinkedField",
                "name": "appTsByAccountId",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AppT",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                      (v6/*: any*/),
                      (v7/*: any*/),
                      (v8/*: any*/),
                      (v9/*: any*/),
                      (v19/*: any*/),
                      (v18/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "appTsByAccountId(orderBy:\"APP_NAME_ASC\")"
              },
              (v18/*: any*/)
            ],
            "storageKey": null
          },
          (v13/*: any*/),
          (v14/*: any*/),
          (v15/*: any*/),
          (v16/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "AccountPackageT",
            "kind": "LinkedField",
            "name": "accountPackageTByAccountPackageId",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "AccountPackageAppTsConnection",
                "kind": "LinkedField",
                "name": "accountPackageAppTsByAccountPackageId",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AccountPackageAppT",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                      (v6/*: any*/),
                      (v16/*: any*/),
                      (v17/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "AppT",
                        "kind": "LinkedField",
                        "name": "appTByAppId",
                        "plural": false,
                        "selections": [
                          (v7/*: any*/),
                          (v8/*: any*/),
                          (v9/*: any*/),
                          (v19/*: any*/),
                          (v18/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v18/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v18/*: any*/)
            ],
            "storageKey": null
          },
          (v18/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "28119d9292d8fece635fc748d285f82a",
    "id": null,
    "metadata": {},
    "name": "SubscriptionOrderLandingEditQuery",
    "operationKind": "query",
    "text": "query SubscriptionOrderLandingEditQuery(\n  $subscriptionOrderLandingId: UUID!\n) {\n  subscriptionOrderLandingTBySubscriptionOrderLandingId(subscriptionOrderLandingId: $subscriptionOrderLandingId) {\n    accountTByAccountId {\n      logo\n      accountPath\n      appTsByAccountId(orderBy: APP_NAME_ASC) {\n        totalCount\n        nodes {\n          appId\n          appName\n          appSku\n          appStatus\n          cpAppTsByAppId {\n            totalCount\n            nodes {\n              cpId\n              cpTByCpId {\n                programName\n                nodeId\n              }\n              nodeId\n            }\n          }\n          nodeId\n        }\n      }\n      nodeId\n    }\n    landingPath\n    pageTitle\n    commissionTitle\n    accountPackageId\n    accountPackageTByAccountPackageId {\n      accountPackageAppTsByAccountPackageId {\n        nodes {\n          appId\n          accountPackageId\n          accountPackageAppId\n          appTByAppId {\n            appName\n            appSku\n            appStatus\n            cpAppTsByAppId {\n              totalCount\n              nodes {\n                cpId\n                cpTByCpId {\n                  programName\n                  nodeId\n                }\n                nodeId\n              }\n            }\n            nodeId\n          }\n          nodeId\n        }\n      }\n      nodeId\n    }\n    nodeId\n  }\n}\n"
  }
};
})();

node.hash = "a2d2e4f10c8047ce7e26e996069965d2";

module.exports = node;
